import React from 'react'
import styled from 'styled-components'

import { strings } from '@constants'
import { Spacings } from '@styles'
import { displayAmount, showDateFormat } from '@utils'
import { DrawerBodyWrapper } from '@base'
import { Pill } from '@baseV2'

import { SectionCard, FieldGrid, Field, FieldLabel, FieldValue } from '../styles'

const Body = styled(DrawerBodyWrapper)`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
`

const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.primary};
`

const RemarkRow = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};

	& > span:first-child {
		font-weight: 600;
		color: ${({ theme }) => theme.colors.text.secondary};
	}
`

const LedgerDetails = ({ rowData }) => {
	const fields = [
		{ label: strings(['original', 'document', 'number']), value: rowData?.original_document_number ?? '-' },
		{ label: strings('invoice', 'date'), value: rowData?.transaction_date ? showDateFormat(new Date(rowData?.transaction_date)) : '-' },
		{ label: strings('amount'), value: displayAmount(rowData?.transaction_amount) ?? '-' },
		{ label: strings('balance'), value: displayAmount(rowData?.balance) ?? '-' },
		{ label: strings('transaction', 'type'), value: rowData?.transaction_type ?? '-' },
		{ label: strings('due', 'date'), value: rowData?.due_date ? showDateFormat(new Date(rowData?.due_date)) : '-' },
		{ label: strings('zoho', 'id'), value: rowData?.zoho_id ?? '-' },
		{ label: strings('order', 'id'), value: rowData?.order_id ?? '-' },
		{ label: strings('order', 'date'), value: rowData?.order_date ? showDateFormat(new Date(rowData?.order_date)) : '-' },
		{ label: strings('platform'), value: rowData?.platform ?? '-' },
		{ label: strings('region'), value: rowData?.region ? rowData?.region : '-' },
		{ label: strings('commodity'), value: rowData?.commodity?.commodity_name ?? '-' },
		{ label: strings('transaction', 'source'), value: rowData?.transaction_source ?? '-' },
		{
			label: strings('sales', 'manager'),
			value: (rowData?.sales_managers?.[0]?.full_name || rowData?.sales_managers?.[0]?.organisation_name) ?? '-',
		},
		{ label: strings('supply', 'manager'), value: (rowData?.supply_managers?.[0]?.full_name || rowData?.supply_managers?.[0]?.organisation_name) ?? '-' },
	]

	return (
		<Body>
			<HeaderRow>
				<span>{`${rowData?.user_details?.organisation_name} (${rowData?.user_details?.organisation_id})`}</span>
				<Pill>{rowData?.zoho_status ?? '-'}</Pill>
			</HeaderRow>
			<SectionCard>
				<FieldGrid>
					{fields.map((f, index) => (
						<Field key={`ledger-field-${index}`}>
							<FieldLabel>{f.label}</FieldLabel>
							<FieldValue>{f.value}</FieldValue>
						</Field>
					))}
				</FieldGrid>
			</SectionCard>
			<RemarkRow>
				<span>{strings('remarks')}</span>
				<span>{rowData?.transaction_remarks ?? '-'}</span>
			</RemarkRow>
		</Body>
	)
}

export default LedgerDetails
